export function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export function highlightMatch(text, query) {
  const value = text == null ? "" : String(text)
  const term = (query || "").trim()
  if (!value || !term) {
    return value
  }
  const pattern = new RegExp(`(${escapeRegExp(term)})`, "ig")
  return value
    .split(pattern)
    .filter((part) => part !== "")
    .map((part, index) =>
      part.toLowerCase() === term.toLowerCase() ? (
        <mark key={`${part}-${index}`}>{part}</mark>
      ) : (
        part
      )
    )
}

export function getSearchByOption(options, value) {
  return options.find((option) => option.value === value) || options[0]
}

const SUGGESTION_URL_PARAMS = {
  offer: "ofid",
  email: "emtid",
  sms: "smid",
  meeting: "mtid",
  call: "clid",
  note: "ntid",
}

export function getSuggestionPath(item) {
  if (!item) {
    return null
  }
  if (item.type === "lead" && item.lead_source) {
    return `/leads/${item.lead_source}/${item.id}`
  }
  if (item.type === "workflow") {
    return `/workflows/${item.id}`
  }
  if (item.type === "sms_template") {
    return `/templates/sms?id=${item.id}`
  }
  if (item.type === "task") {
    return `/tasks?id=${item.id}`
  }
  const candidateId =
    item.candidate_id || (item.type === "candidate" ? item.id : null)
  if (!candidateId) {
    return null
  }
  if (item.type === "candidate" || !SUGGESTION_URL_PARAMS[item.type]) {
    return `/candidates/${candidateId}`
  }
  return `/candidates/${candidateId}?${SUGGESTION_URL_PARAMS[item.type]}=${
    item.id
  }`
}

export function getSeeAllPath(searchBy, query) {
  const params = new URLSearchParams()
  if (query) {
    params.append("q", query)
  }
  const suffix = params.toString() ? `?${params.toString()}` : ""
  if (searchBy === "lead") {
    const leadParams = new URLSearchParams()
    leadParams.append("tab", "mls")
    if (query) {
      leadParams.append("q", query)
    }
    return `/leads/?${leadParams.toString()}`
  }
  if (searchBy === "workflow") {
    return `/workflows${suffix}`
  }
  if (searchBy === "sms") {
    return `/templates/sms${suffix}`
  }
  if (searchBy === "task") {
    return `/tasks${suffix}`
  }
  return `/candidates${suffix}`
}
